import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import { Form, Input, Row, Col, Button, Select, notification } from "antd";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  addProDetail,
  addSelectedProduction,
  emptySelectedProduction,
  setSelectedprod,
  toggleNewDialog,
  toggleNewEditDialog,
  updateSelectedProduction,
  updateSelectedRawMaterial,
} from "../store/stateSlice";
import { DatePicker, Space } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ProductionTable from "./ProductionTable";
import {
  getProcess,
  getProduct,
  getWorker,
  postProduction,
  getallProduction,
  updateProduction,
} from "../store/dataSlice";
import { getOrderID } from "../../RawMaterial/store/dataSlice";
import { detailProduction } from "../store/dataSlice";

const ProductionForm = ({ type }) => {
  const [orderId, setOrderId] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();

  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const processList = useSelector(
    (state) => state.production.data.processList?.data
  );

  const workerList = useSelector(
    (state) => state.production.data.workerList?.data
  );
  const productList = useSelector(
    (state) => state.production.data.productList?.data
  );
  const orderID = useSelector(
    (state) => state.rawMaterial.data.orderIdList?.data
  );
  const ProductionData = useSelector(
    (state) => state.production.data.detailProduction
  );
  const selectedProduction = useSelector(
    (state) => state.production.state.selectedprod
  );
  const data = useSelector(
    (state) => state.production.state.selectedproduction
  );
  const editProduction = useSelector(
    (state) => state.production.state.selectedEditProduction
  );
  const validationSchema = Yup.object({
    Order_No: Yup.string().required("Order No is required"),
    Expected_Completion_Date: Yup.string().required(
      "Expected Completion Date is required"
    ),
    Product: Yup.string().required("Product is required"),
    Date_to_Date: Yup.string().required("Date to Date is required"),
    Processes: Yup.string().required("Processes is required"),
    Employee_Name: Yup.string().required("Employee Name is required"),
    Quantity: Yup.string().required("Quantity is required"),
    Description: Yup.string().required("Description is required"),
  });

  let initialValues = editProduction || {
    order_id: "",
    completion_date: "",
    product: "",
    start_date: "",
    end_date: "",
    processes: "",
    worker_name: [],
    quantity: "",
    description: "",
  };

  useEffect(() => {
    dispatch(getOrderID());
    dispatch(getProcess());
  }, [dispatch]);

  const handleCancel = () => {
    dispatch(toggleNewDialog(false));
  };

  useEffect(() => {
    if (type === "edit") {
      // Fetch production details only if ProductionData is empty
      if (Object.keys(ProductionData).length === 0) {
        dispatch(
          detailProduction({
            production_plan_id: selectedProduction.production_plan_id,
          })
        );
      } else {
        setOrderId(selectedProduction?.order_id);
        setCompletionDate(selectedProduction?.completion_date);
        dispatch(getProduct({ order_id: ProductionData?.order_id }));
        dispatch(addProDetail(ProductionData.ProductionPlanDetails));
      }
    }
  }, [type, selectedProduction, ProductionData]);

  const handleSave = async (data) => {
    if (!orderId) {
      return notification.error({ message: "Please Select Order Number" });
    }
    if (!completionDate) {
      return notification.error({ message: "Please Select Completion Date" });
    }
    let result = {
      tasks: data.map((m) => {
        const {
          Product,
          quantity,
          start_date,
          end_date,
          description,
          Process,
          Worker,
        } = m;

        return {
          start_date,
          end_date,
          description,
          quantity: parseFloat(quantity),
          product_id: Product.product_id,
          process_id: Process.process_id,
          worker_id: Worker.worker_id,
        };
      }),
    };

    if (type === "edit") {
      result.order_id = orderId;
      result.production_plan_id = selectedProduction?.production_plan_id;
      result.completion_date = completionDate;
      const action = await dispatch(updateProduction(result));
      if (action.payload.status < 300) {
        notification.success({
          message: "Production Plan Updated successfully!",
        });
        dispatch(toggleNewEditDialog(false));
        dispatch(emptySelectedProduction([]));
        dispatch(setSelectedprod({}));
        setOrderId("");
        setCompletionDate("");
        dispatch(getallProduction());
      } else {
        notification.error({ message: action?.payload });
      }
    } else {
      result.order_id = orderId;
      result.completion_date = completionDate;
      const action = await dispatch(postProduction(result));
      if (action.payload.status < 300) {
        notification.success({
          message: "Production Plan Submitted successfully!",
        });
        dispatch(toggleNewDialog(false));
        dispatch(emptySelectedProduction([]));
        setOrderId("");
        setCompletionDate("");
        dispatch(getallProduction());
      } else {
        notification.error({ message: action?.payload });
      }
    }
  };

  const handleSubmit = (
    values,
    { setSubmitting, resetForm, setFieldValue }
  ) => {
    console.log(values);

    if (editProduction && Object.keys(editProduction).length > 0) {
      dispatch(updateSelectedProduction(values));
    } else {
      dispatch(addSelectedProduction(values));
    }

    setFieldValue("Product", "");
    setFieldValue("start_date", "");
    setFieldValue("end_date", "");
    setFieldValue("Process", "");
    setFieldValue("Worker", []);
    setFieldValue("quantity", "");
    setFieldValue("description", "");
    setSubmitting(false);
  };

  // {
  //   order_id:
  //     type === "edit"
  //       ? Object.keys(BomData).length > 0
  //         ? BomData?.order_id
  //         : ""
  //       : editRawMaterial?.order_id || "",
  //   date: editRawMaterial?.date || "",
  //   Product: editRawMaterial?.Product || "",
  //   quantity: editRawMaterial?.quantity || "",
  //   description: editRawMaterial?.description || "",
  // }

  console.log(orderId);
  console.log(completionDate);
  return (
    <>
      <div className="mt-4">
        {contextHolder}
        <Formik
          enableReinitialize
          initialValues={{
            // order_id:
            //   type === "edit"
            //     ? Object.keys(ProductionData).length > 0
            //       ? ProductionData?.order_id
            //       : ""
            //     : editProduction?.order_id || "",
            // completion_date:
            //   type === "edit"
            //     ? Object.keys(ProductionData).length > 0
            //       ? ProductionData?.completion_date
            //       : ""
            //     : editProduction?.completion_date || "",
            order_id: orderId,
            completion_date: completionDate,
            Product: editProduction?.Product || "",
            start_date: editProduction?.start_date || "",
            end_date: editProduction?.end_date || "",
            Process: editProduction?.Process || "",
            Worker: editProduction?.Worker || [],
            quantity: editProduction?.quantity || "",
            description: editProduction?.description || "",
          }}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            if (values.order_id) {
              setOrderId(values.order_id);
            }
            if (values.completion_date) {
              setCompletionDate(values.completion_date);
            }

            return (
              <Form
                className=""
                onFinish={handleSubmit}
                onFinishFailed={(errorInfo) => {
                  console.error("Failed:", errorInfo);
                }}
              >
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.order_id && errors.order_id
                          ? errors.order_id
                          : ""
                      }
                      validateStatus={
                        touched.order_id && errors.order_id
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Order No.</span>
                      <Select
                        showSearch
                        placeholder="Select Order No"
                        onChange={(value) => {
                          setFieldValue("order_id", value);
                          if (value) {
                            dispatch(getProduct({ order_id: value }));
                          }
                        }}
                        disabled={type === "edit"}
                        value={values.order_id}
                        className="h-[40px] rounded"
                      >
                        {orderID?.map((type) => (
                          <Option
                            key={type.order_id}
                            value={type.order_id}
                            className="text-gray-400"
                          >
                            {type.order_number}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.expected_completion_date &&
                        errors.expected_completion_date
                          ? errors.expected_completion_date
                          : ""
                      }
                      validateStatus={
                        touched.expected_completion_date &&
                        errors.expected_completion_date
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Expected Completion Date</span>
                      <Field name="completion_date">
                        {({ field, form }) => (
                          <DatePicker
                            {...field}
                            value={field.value ? moment(field.value) : null}
                            onChange={(date, dateString) =>
                              form.setFieldValue("completion_date", dateString)
                            }
                            onBlur={form.handleBlur}
                            className="!rounded"
                            style={{ width: "100%", padding: "8px" }}
                          />
                        )}
                      </Field>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.product && errors.product ? errors.product : ""
                      }
                      validateStatus={
                        touched.product && errors.product ? "error" : undefined
                      }
                    >
                      <span className="text-xs">Product</span>
                      <Select
                        showSearch
                        name="product"
                        placeholder="Select Product"
                        value={values.Product?.product_id}
                        onChange={(value) => {
                          const selectedProduct = productList.find(
                            (type) => type.Product?.product_id === value
                          );

                          if (selectedProduct) {
                            handleChange({
                              target: {
                                name: "Product",
                                value: {
                                  product_id:
                                    selectedProduct.Product.product_id,
                                  part_name: selectedProduct.Product.part_name,
                                  description:
                                    selectedProduct.Product.description,
                                  drawing_number:
                                    selectedProduct.Product.drawing_number,
                                  material_grade_id:
                                    selectedProduct.Product.MaterialGrade
                                      ?.number,
                                },
                              },
                            });
                          }
                        }}
                        className="h-[40px] rounded"
                      >
                        {productList?.map((type) => (
                          <Option
                            key={type.Product?.product_id}
                            value={type.Product?.product_id}
                            className="text-gray-400"
                          >
                            {`${type.Product?.part_name} : ${type.Product?.MaterialGrade?.number}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.Date_to_Date && errors.Date_to_Date
                          ? errors.Date_to_Date
                          : ""
                      }
                      validateStatus={
                        touched.Date_to_Date && errors.Date_to_Date
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">From Date-to-Date</span>
                      <div className="">
                        <Space direction="vertical" size={12}>
                          <RangePicker
                            className="w-full h-11"
                            value={[
                              values.start_date
                                ? moment(values.start_date)
                                : null,
                              values.end_date ? moment(values.end_date) : null,
                            ]}
                            showTime={{
                              format: "HH:mm",
                            }}
                            format="YYYY-MM-DD HH:mm"
                            allowEmpty={[true, true]}
                            onChange={(dates, dateStrings) => {
                              setFieldValue(
                                "start_date",
                                dates ? dateStrings[0] : null
                              );
                              setFieldValue(
                                "end_date",
                                dates ? dateStrings[1] : null
                              );
                              dispatch(
                                getWorker({
                                  startDate: dateStrings[0],
                                  endDate: dateStrings[1],
                                })
                              );
                            }}
                          />
                        </Space>
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.processes && errors.processes
                          ? errors.processes
                          : ""
                      }
                      validateStatus={
                        touched.processes && errors.processes
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Process</span>
                      <Select
                        showSearch
                        placeholder="Select Processes"
                        onChange={(value) => {
                          const selectedProcess = processList.find(
                            (type) => type.process_id === value
                          );

                          if (selectedProcess) {
                            handleChange({
                              target: {
                                name: "Process",
                                value: {
                                  process_id: selectedProcess.process_id,
                                  process_name: selectedProcess.process_name,
                                },
                              },
                            });
                          }
                        }}
                        value={values.Process?.process_id || ""}
                        className="h-[40px] rounded"
                      >
                        {processList?.map((type) => (
                          <Option
                            key={type.process_id}
                            value={type.process_id}
                            className="text-gray-400"
                          >
                            {type.process_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.worker_name && errors.worker_name
                          ? errors.worker_name
                          : ""
                      }
                      validateStatus={
                        touched.worker_name && errors.worker_name
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Workers</span>
                      <Select
                        mode="multiple"
                        showSearch
                        placeholder="Select Worker Name"
                        disabled={
                          editProduction &&
                          Object.keys(editProduction).length > 0
                        }
                        onChange={(value) => {
                          const selectedWorkers = workerList.filter((type) =>
                            value.includes(type.worker_id)
                          );

                          handleChange({
                            target: {
                              name: "Worker",
                              value: selectedWorkers.map((worker) => ({
                                worker_id: worker.worker_id,
                                worker_name: worker.worker_name,
                              })),
                            },
                          });
                        }}
                        value={
                          values.Worker.map((worker) => worker.worker_id) || []
                        }
                        className=" rounded"
                      >
                        {workerList?.map((type) => (
                          <Option
                            key={type.worker_id}
                            value={type.worker_id}
                            className="text-gray-400"
                          >
                            {type.worker_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.Quantity && errors.Quantity
                          ? errors.Quantity
                          : ""
                      }
                      validateStatus={
                        touched.Quantity && errors.Quantity
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Quantity</span>
                      <Input
                        name="quantity"
                        placeholder="Quantity"
                        value={values.quantity}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="!rounded"
                        style={{ padding: "8px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.Description && errors.Description
                          ? errors.Description
                          : ""
                      }
                      validateStatus={
                        touched.Description && errors.Description
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Description</span>
                      <Input
                        name="description"
                        placeholder="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="!rounded"
                        style={{ padding: "8px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Button
                      htmlType="submit"
                      disabled={isSubmitting}
                      type="primary"
                      className="mt-6"
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
      <ProductionTable />
      <div className="flex justify-end m-4 gap-2">
        <Button type="primary" onClick={() => handleSave(data)}>
          Save & Close
        </Button>
      </div>
    </>
  );
};

export default ProductionForm;
